// @ts-nocheck

export default {
  "l10n": {
    "currency": '\u20ac',
    "date": {
      "months": {
        "full": ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
        "abbr": ["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic."]
      },
      "days": {
        "full": ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"],
        "abbr": ["do.","lu.","ma.","mi.","ju.","vi.","sá."]
      },
      "patterns": {
        "longDate": "dddd, D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateShortWithDay": "Do MMMM YYYY",
        "dateMedium": "dddd, D [de] MMMM - HH[:]mm [h]",
        "dateMediumReversed" : "H[:]mm - D MMMM YYYY",
        "dateMediumSlash": "DD[/]MM[/]YYYY [a las] H[:]mm",
        "dateLarge": "dddd, D [de] MMMM [a las] HH[:]mm",
        "timeShort": "HH:mm",
        "timeMedium": "DD[/]MM [•] HH:mm",
        "timeLarge": "DD[/]MM[/]YY [•] LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-n S", "n S"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "plural": "nplurals=2; plural=(n != 1);",
      "ordinal": function(number) { return number + (number === 1 ? '°' : '°'); }
    }
  },
  "translations": {
    "messages": {
  "!action:Bet": [
    null,
    "Apostar"
  ],
  "!action:GiftRace Start": [
    null,
    "Participo"
  ],
  "!action:Settings": [
    null,
    "Configurar"
  ],
  "!action:Share": [
    null,
    "Compartir"
  ],
  "!action:deleteAndContinue": [
    null,
    "Borrar y continuar"
  ],
  "!action:viewMyNonValidatedBets": [
    null,
    "Ver mis apuestas sin validar"
  ],
  "!desc:%1$s ES RM J-30 warning": [
    null,
    "%1$s en conformidad con el artículo 13 del Real Decreto 958/2020, no podrás beneficiarte de esta promoción hasta que tu cuenta haya sido validada y hayan pasado al menos 30 días desde que la abriste."
  ],
  "!desc:ArjelAdvice": [
    null,
    "Cualquier persona que desee autoexcluirse del juego deberá hacerlo en el Ministerio del Interior. Esta prohibición es válida en los casinos, círculos de juego y salas de juego en línea, en aplicación de la ley nº 2010-476 del 12 de mayo de 2010. La autoexclusión se extiende por una duración de tres años no reducible."
  ],
  "!desc:ArjelLink": [
    null,
    "Interdicción voluntaria del juego"
  ],
  "!desc:ArjelTitle": [
    null,
    "Winamax est agréé par l'Agence Nationale des Jeux"
  ],
  "!desc:BROptaWidgetWarning": [
    null,
    "Los resultados de las apuestas a tiros se basan en las estadísticas oficiales del organizador y no en las estadísticas que se muestran arriba."
  ],
  "!desc:BasketHowTo": [
    null,
    "Añade selecciones haciendo clic en las cuotas"
  ],
  "!desc:BetBuilderHelper": [
    null,
    "Con MyMatch, crea tu apuesta eligiendo varias selecciones sobre un mismo partido y obtén tu cuota personalizada."
  ],
  "!desc:BetBuilderHelperBasketball": [
    null,
    "Con MyMatch, crea tu apuesta eligiendo varias selecciones sobre un mismo partido (ganador del partido, número de puntos/rebotes/asistencias de un jugador) y obtén tu cuota personalizada."
  ],
  "!desc:BetBuilderHelperSoccer": [
    null,
    "Con MyMatch, crea tu apuesta eligiendo varias selecciones sobre un mismo partido (resultado al descanso, resultado exacto, número de goles, goleadores...) y obtén tu cuota personalizada."
  ],
  "!desc:BetshareWebsite": [
    null,
    "winamax.es"
  ],
  "!desc:BzgaLegals": [
    null,
    "Eigentümer und Betreiber - Winamax SA - 136 B Rue de Grenelle, 75007 Paris, Frankreich\nGlücksspiel kann süchtig machen. Hilfe unter"
  ],
  "!desc:CashoutPendingRegulation": [
    null,
    "The Cashout amount is only paid out when all selections of the bet have been settled"
  ],
  "!desc:ClientUpdaterContent": [
    null,
    "Para actualizar el software, desinstala esta versión y descarga el nuevo software directamente desde la App Store."
  ],
  "!desc:ClientUpdaterContentDeprecated": [
    null,
    "Esta versión no cuenta con las últimas mejoras y va a bloquearse muy pronto."
  ],
  "!desc:DEBetTaxFreeDescription": [
    null,
    ""
  ],
  "!desc:DVTMLink": [
    null,
    "Verantwortliches Spiel"
  ],
  "!desc:DgojConfidentiality": [
    null,
    "Política de privacidad"
  ],
  "!desc:DgojLicence": [
    null,
    "WINAMAX, S.A. Todos los derechos reservados. Domicilio social en Rue de Grenelle, 136bis, París (Francia) y dirección a efectos de representación en España en Paseo de la Castellana, 35, 5ª planta, Madrid.\n\nLa Dirección General de Ordenación del Juego ha concedido a Winamax las siguientes licencias: OTROS JUEGOS, APUESTAS, PÓQUER, APUESTAS DEPORTIVAS DE CONTRAPARTIDA. "
  ],
  "!desc:DgojResponsibleGaming": [
    null,
    "Juego responsable"
  ],
  "!desc:DgojResponsibleGamingTextES": [
    null,
    "Esto es una aplicación de juegos de azar con dinero real. Juega de manera responsable y no pongas en juego más dinero del que puedes permitirte. Para obtener ayuda y apoyo con la adicción al juego, ponte en contacto con FEJAR en el 900 533 025 y visita https://fejar.org/"
  ],
  "!desc:DgojTerms": [
    null,
    "Términos y condiciones"
  ],
  "!desc:DocumentTitle": [
    null,
    "Apuestas deportivas I Winamax apuestas deportivas I Apuestas online"
  ],
  "!desc:DocumentTitleLive": [
    null,
    "Apuesta en directo - Apuesta en directo en Winamax"
  ],
  "!desc:FreebetHelper": [
    null,
    "Puedes conseguir freebets con nuestras promociones.\nEn el caso de que realices una apuesta con una freebet y la ganes, recibirás en tu cuenta únicamente las ganancias netas (ganancias - importe apostado)."
  ],
  "!desc:GoalScorersHelper": [
    null,
    "Apuesta al jugador que marcará al menos un gol o al primero o último goleador del partido. Esta apuesta no tiene en cuenta eventuales prórrogas o tandas de penaltis. Los goles en propia puerta no son contabilizados. Si el primer (o en su caso último) gol del partido es un gol marcado en propia puerta, el jugador que marque el siguiente gol (o el anterior), será considerado como el primer (o último) goleador del partido."
  ],
  "!desc:HuntingAllStarsEnrollmentMainDescription": [
    null,
    "¡Coto de caza abierto!\nSupera las 3 fases del juego encadenando apuestas ganadoras.\nReúne los 3 conejos all-stars y vuelve a casa cargado de Freebets."
  ],
  "!desc:Minus18DE": [
    null,
    "Minderjährigen ist die Benutzung verboten"
  ],
  "!desc:MonopolyEnrollmentMessage": [
    null,
    "¡Completa las colecciones Monopoly gracias a tus apuestas y llévate Freebets!"
  ],
  "!desc:PanicButtonConfirmation": [
    null,
    "You have activated a 24h break across all providers. You can play again earliest on tomorrow at %1$s."
  ],
  "!desc:PanicButtonConfirmationTitle": [
    null,
    "Your account is on a break"
  ],
  "!desc:RealityCheckMessage": [
    null,
    "No olvides realizar pausas regulares. Te recordamos que puedes encontrar más información al respecto en la sección \"Juego más seguro\" en nuestra página web."
  ],
  "!desc:ResponsibleGamingTextFR": [
    null,
    "Esto es una aplicación de juegos de azar con dinero real. Juega de manera responsable y no pongas en juego más dinero del que puedes permitirte. Para obtener ayuda y apoyo con la adicción al juego, ponte en contacto con joueurs-info-service en el 09-74-75-13-13 o visita http://www.joueurs-info-service.fr/."
  ],
  "!desc:SoccerDecisivePlayer": [
    null,
    "Con respecto a las apuestas \"Jugador decisivo\" y \"Asistente\", las apuestas se anularán si el jugador en cuestión no juega. El resultado de las apuestas se basa en las estadísticas Opta.\nEl jugador será decisivo en el partido, es decir, que marcará al menos un gol o hará al menos una asistencia (sin prórroga ni penaltis)."
  ],
  "!desc:SoccerScorerDuo": [
    null,
    "Apuesta al número de goles que marcarán los dos jugadores durante el partido (eventuales prórrogas y tandas de penaltis no incluidas). La apuesta se anulará si alguno de los jugadores seleccionados no juega."
  ],
  "!desc:SoccerScorerTrio": [
    null,
    "Apuesta al número de goles que marcarán los tres jugadores durante el partido (eventuales prórrogas y tandas de penaltis no incluidas). La apuesta se anulará si alguno de los jugadores seleccionados no juega."
  ],
  "!desc:SrijLicence": [
    null,
    "WINAMAX, S.A. Todos os direitos reservados. É uma empresa registada em Portugal com o número de empresa XXXXXXXXX, com sede na XXXXXXXX, em XXXXX e é titular das licenças de jogo n° XXX e XXX emitidas pelo SRIJ – Serviço de Regulação e Inspeção de Jogos que a autoriza a desenvolver a atividade de exploração de apostas desportivas à cota e de jogos de fortuna ou azar online em Portugal."
  ],
  "!desc:activateLineUpNotifications": [
    null,
    "¿Quieres recibir una notificación en cuanto se anuncie el once en tus partidos favoritos?\nActiva las notificaciones desde tus preferencias de comunicación"
  ],
  "!desc:userAlreadyOptedIn": [
    null,
    "Ya participas en esta operación."
  ],
  "!noun:GridsCancelled": [
    null,
    "-"
  ],
  "!noun:GridsFilterCancelled": [
    null,
    "-"
  ],
  "!noun:GridsFilterLost": [
    null,
    "-"
  ],
  "!noun:GridsFilterRunning": [
    null,
    "-"
  ],
  "!noun:GridsFilterWon": [
    null,
    "-"
  ],
  "!noun:GridsFinancing": [
    null,
    "-"
  ],
  "!noun:GridsFinished": [
    null,
    "-"
  ],
  "!noun:GridsLost": [
    null,
    "-"
  ],
  "!noun:GridsNotValidated": [
    null,
    "-"
  ],
  "!noun:GridsRunning": [
    null,
    "-"
  ],
  "!noun:GridsWon": [
    null,
    "-"
  ],
  "!noun:MonopolyWon": [
    "!noun:MonopolyWonPlural",
    "Conseguida:",
    "Conseguidas:"
  ],
  "!noun:Rules": [
    null,
    "Reglamento"
  ],
  "!noun:Welcome": [
    null,
    "Bienvenido"
  ],
  "!noun:Won": [
    null,
    "Conseguido"
  ],
  "!plural:Finished": [
    null,
    "Finalizadas"
  ],
  "!plural:Won": [
    null,
    "Ganadas"
  ],
  "!scorer:Next": [
    null,
    "Siguiente"
  ],
  "!short:1st half - 2 or more": [
    null,
    "1ª mitad - 2 o más"
  ],
  "!short:1st half - 3 or more": [
    null,
    "1ª mitad - 3 o más"
  ],
  "!short:1st half - 4 or more": [
    null,
    "1ª mitad - 4 o más"
  ],
  "!short:1st period - Scorer": [
    null,
    "1° periodo - Goleador"
  ],
  "!short:2 or more": [
    null,
    "2 o más"
  ],
  "!short:2nd half - 2 or more": [
    null,
    "2ª mitad - 2 o más"
  ],
  "!short:2nd half - 3 or more": [
    null,
    "2ª mitad - 3 o más"
  ],
  "!short:2nd half - 4 or more": [
    null,
    "2ª mitad - 4 o más"
  ],
  "!short:2nd period - Scorer": [
    null,
    "2° periodo - Goleador"
  ],
  "!short:3 or more": [
    null,
    "3 o más"
  ],
  "!short:3rd period - Scorer": [
    null,
    "3° periodo - Goleador"
  ],
  "!short:4 or more": [
    null,
    "4 o más"
  ],
  "!short:AdditionnalTime": [
    null,
    "EA"
  ],
  "!short:Anytime goalscorer": [
    null,
    "Goleador"
  ],
  "!short:BothHalf": [
    null,
    "Ambas"
  ],
  "!short:Double": [
    null,
    "Doblete"
  ],
  "!short:Draw": [
    null,
    "X"
  ],
  "!short:First": [
    null,
    "Primer"
  ],
  "!short:FirstHalf": [
    null,
    "1ª mitad"
  ],
  "!short:HalfTime": [
    null,
    "Des"
  ],
  "!short:Hat-trick": [
    null,
    "Triplete"
  ],
  "!short:Last": [
    null,
    "Último"
  ],
  "!short:Next": [
    null,
    "Próximo"
  ],
  "!short:Overtime": [
    null,
    "Pror"
  ],
  "!short:Overtime - 2 or more": [
    null,
    "Prórroga - 2 o más"
  ],
  "!short:PenaltyShootOut": [
    null,
    "Pen"
  ],
  "!short:Points": [
    null,
    "Pts"
  ],
  "!short:RegularTime": [
    null,
    "T.Regl"
  ],
  "!short:ScorerConversion": [
    null,
    "C"
  ],
  "!short:ScorerDrop": [
    null,
    "D"
  ],
  "!short:ScorerPenalty": [
    null,
    "P"
  ],
  "!short:SecondHalf": [
    null,
    "2ª mitad"
  ],
  "!short:Today": [
    null,
    "Hoy"
  ],
  "!short:bet": [
    "!short:bets",
    "apues.",
    "apues."
  ],
  "%1$s (multiple chance)": [
    null,
    "%1$s multiopción"
  ],
  "%1$s + %2$s": [
    null,
    "%1$s + %2$s"
  ],
  "%1$s Base": [
    "%1$s Bases",
    "%1$s banker",
    "%1$s bankers"
  ],
  "%1$s bet": [
    "%1$s bets",
    "%1$s apuesta",
    "%1$s apuestas"
  ],
  "%1$s bet added": [
    "%1$s bets added",
    "%1$s apuesta añadida",
    "%1$s apuestas añadidas"
  ],
  "%1$s bet could not be validated": [
    "%1$s bets could not be validated",
    "%1$s apuesta no ha podido ser validada",
    "%1$s apuestas no han podido ser validadas"
  ],
  "%1$s bet selected": [
    "%1$s bets selected",
    "%1$s apuesta seleccionada",
    "%1$s apuestas seleccionadas"
  ],
  "%1$s guarenteed ": [
    null,
    "%1$s garantizados"
  ],
  "%1$s internal error": [
    null,
    "Error interno de la %1$s"
  ],
  "%1$s or more": [
    null,
    "%1$s o más"
  ],
  "%1$s selection": [
    "%1$s selections",
    "%1$s selección",
    "%1$s selecciones"
  ],
  "%1$s selection could not be added": [
    "%1$s selections could not be added",
    "%1$s selección no ha podido ser añadida",
    "%1$s selecciones no han podido ser añadidas"
  ],
  "%1$s single bet": [
    "%1$s single bets",
    "%1$s apuesta simple",
    "%1$s apuestas simples"
  ],
  "%1$s's bet": [
    null,
    "Apuesta de %1$s"
  ],
  "%1$s-%2$s PSO": [
    null,
    "pen. %1$s-%2$s"
  ],
  "%1$s-%2$s a.e.t.": [
    null,
    "%1$s-%2$s Pr"
  ],
  "%1$s-%2$s reg. time": [
    null,
    "90' %1$s-%2$s"
  ],
  "%1$s:": [
    null,
    "%1$s:"
  ],
  "(1 to %1$s)": [
    null,
    "(1 a %1$s)"
  ],
  "+%1$s min": [
    null,
    "+%1$s min."
  ],
  "10th set": [
    null,
    "10º set"
  ],
  "12-grids": [
    null,
    "-"
  ],
  "1st": [
    null,
    "1º"
  ],
  "1st half": [
    null,
    "1ª mitad"
  ],
  "1st innings": [
    null,
    "1ª entrada"
  ],
  "1st period": [
    null,
    "1er periodo"
  ],
  "1st quarter": [
    null,
    "1er periodo"
  ],
  "1st set": [
    null,
    "1er set"
  ],
  "2 or more": [
    null,
    "2 o más"
  ],
  "24-hour break": [
    null,
    ""
  ],
  "2nd": [
    null,
    "2º"
  ],
  "2nd half": [
    null,
    "2ª mitad"
  ],
  "2nd half - Multiple goalscorers": [
    null,
    "2ª mitad - Goleadores múltiples"
  ],
  "2nd innings": [
    null,
    "2ª entrada"
  ],
  "2nd period": [
    null,
    "2º periodo"
  ],
  "2nd quarter": [
    null,
    "2º periodo"
  ],
  "2nd set": [
    null,
    "2º set"
  ],
  "3 or more": [
    null,
    "3 o más"
  ],
  "3rd": [
    null,
    "3º"
  ],
  "3rd innings": [
    null,
    "3ª entrada"
  ],
  "3rd period": [
    null,
    "3er periodo"
  ],
  "3rd quarter": [
    null,
    "3er periodo"
  ],
  "3rd set": [
    null,
    "3er set"
  ],
  "4 or more": [
    null,
    "4 o más"
  ],
  "4th innings": [
    null,
    "4ª entrada"
  ],
  "4th quarter": [
    null,
    "4º periodo"
  ],
  "4th set": [
    null,
    "4º set"
  ],
  "5th innings": [
    null,
    "5ª entrada"
  ],
  "5th set": [
    null,
    "5º set"
  ],
  "6th innings": [
    null,
    "6ª entrada"
  ],
  "6th set": [
    null,
    "6º set"
  ],
  "7-grids": [
    null,
    "-"
  ],
  "7th innings": [
    null,
    "7ª entrada"
  ],
  "7th set": [
    null,
    "7º set"
  ],
  "8th innings": [
    null,
    "8ª entrada"
  ],
  "8th set": [
    null,
    "8º set"
  ],
  "9th innings": [
    null,
    "9ª entrada"
  ],
  "9th set": [
    null,
    "9º set"
  ],
  "A server issue has interrupted media playback.": [
    null,
    "Un problema de red ha interrumpido la reproducción del vídeo."
  ],
  "ALL-IN": [
    null,
    "ALL-IN"
  ],
  "Accept changes": [
    null,
    "Acepta los cambios"
  ],
  "Acces to media failed.": [
    null,
    "Acceso al contenido multimedia imposible de realizar."
  ],
  "Accumulator": [
    null,
    "Combinada"
  ],
  "Accumulator %1$s": [
    null,
    "Combinada %1$s"
  ],
  "Add": [
    null,
    "Añadir"
  ],
  "Add an In-Play selection to get a %1$s bonus": [
    null,
    "Añade una apuesta en directo para obtener un bono del %1$s"
  ],
  "Add bet to basket": [
    null,
    "Añadir la apuesta a mi cesta"
  ],
  "Add one selection to get a %1$s bonus": [
    null,
    "Añade una apuesta para obtener un bono del %1$s"
  ],
  "Additional buttons allow you to make variations of an existing grid.": [
    null,
    "-"
  ],
  "Ajax Amsterdam": [
    null,
    "Ajax Amsterdam"
  ],
  "All": [
    null,
    "Todas"
  ],
  "All my grids": [
    null,
    "-"
  ],
  "All players": [
    null,
    "Todos los jugadores"
  ],
  "All possible accumulators %1$s with %2$s from %3$s others, or %4$s in total": [
    null,
    "Todas las combinadas posibles %1$s con %2$s entre las %3$s otras, o sea %4$s apuestas en total"
  ],
  "All possible accumulators from the %1$s from amongst %2$s, or %3$s in total": [
    null,
    "Todas las combinadas posibles de %1$s entre las %2$s, o sea, %3$s en total"
  ],
  "All rules": [
    null,
    "Reglamento"
  ],
  "Amount": [
    null,
    "Importe"
  ],
  "Amount collected:": [
    null,
    "Importe recaudado:"
  ],
  "Amount shared out:": [
    null,
    "Importe repartido:"
  ],
  "Amount to be carried forward:": [
    null,
    "Importe a repartir:"
  ],
  "An error as occurred.": [
    null,
    "Se ha producido un error."
  ],
  "An error has occured": [
    null,
    "Se ha producido un error"
  ],
  "An error occurred, please try again.": [
    null,
    "Se ha producido un error. Por favor, inténtalo de nuevo."
  ],
  "And remember,": [
    null,
    "Y recuerda,"
  ],
  "And you will unlock phase 2.": [
    null,
    "Y desbloquearás la fase 2"
  ],
  "And you will unlock phase 3.": [
    null,
    "Y desbloquearás la fase 3"
  ],
  "Anytime": [
    null,
    "Goleador"
  ],
  "Assistman": [
    null,
    "Asistente"
  ],
  "Assists": [
    null,
    "Asistencias"
  ],
  "Assists+rebounds": [
    null,
    "Asistencias+rebotes"
  ],
  "At least one of the two teams": [
    null,
    "Al menos uno de los dos equipos"
  ],
  "At least one of your multi-chance selections has too many choices.": [
    null,
    "Al menos una de tus selecciones multiopción presenta demasiadas opciones."
  ],
  "At least one of your selections is currently suspended": [
    null,
    "Al menos una de tus selecciones está suspendida en este momento."
  ],
  "At least one of your selections is no longer available.": [
    null,
    "Al menos una de tus selecciones no está disponible."
  ],
  "At least one of your selections is no longer available. Check your betslip.": [
    null,
    "Al menos una de tus selecciones no está disponible. Verifica la cesta."
  ],
  "At least one of your selections is not eligible for MyMatch.": [
    null,
    "Al menos una de tus selecciones no es elegible al MyMatch."
  ],
  "At least one of your selections is not eligible for MyMatch. Check your betslip.": [
    null,
    "Al menos una de tus selecciones no es elegible al MyMatch. Comprueba la cesta."
  ],
  "Atletico Madrid": [
    null,
    "Atlético Madrid"
  ],
  "Author": [
    null,
    "Creador"
  ],
  "BOOM, easy game!": [
    null,
    "¡Bum! Sencillo, eh."
  ],
  "Back": [
    null,
    "Volver"
  ],
  "Back to grid creation": [
    null,
    "-"
  ],
  "Back to sports betting": [
    null,
    "Regresar a apuestas deportivas"
  ],
  "Back to the grid of the day": [
    null,
    "-"
  ],
  "Balance": [
    null,
    "Saldo"
  ],
  "Base": [
    null,
    "Banker"
  ],
  "Bayern Munich": [
    null,
    "Bayern Múnich"
  ],
  "Best author (badge)": [
    null,
    "Mejor creador (badge)"
  ],
  "Best author (winnings)": [
    null,
    "Mejor creador (ganancias)"
  ],
  "Best bets": [
    null,
    "Mejores apuestas"
  ],
  "Bet": [
    null,
    "Apuesta"
  ],
  "Bet %1$s could not be redeemed, one or more selections are not eligible for Cashout": [
    null,
    "La apuesta %1$s no ha podido ser vendida, ya que una o varias de tus selecciones no son elegibles al Cashout"
  ],
  "Bet %1$s could not be redeemed, remaining bet is less than €0.10": [
    null,
    "La apuesta %1$s no ha podido ser vendida, ya que el importe restante es inferior a 0,10 €"
  ],
  "Bet %1$s could not be redeemed, the Cashout amount has changed": [
    null,
    "La apuesta %1$s no ha podido ser vendida, ya que el importe del Cashout ha cambiado"
  ],
  "Bet confirmation": [
    null,
    "Confirmación de la apuesta"
  ],
  "Bet is limited to free bet": [
    null,
    "Solo puedes apostar utilizando una apuesta gratis"
  ],
  "Bet is not eligible for %1$s": [
    null,
    "La apuesta no es elegible a la %1$s"
  ],
  "Bet is not eligible for %1$s because at least one match starts after the end of the game": [
    null,
    "La apuesta no es elegible a la %1$s ya que al menos un partido empieza tras el final del juego"
  ],
  "Bet is not eligible for %1$s because system bets are not eligible": [
    null,
    "La apuesta no es elegible a la %1$s ya que las apuestas sistema no son elegibles"
  ],
  "Bet is not eligible for %1$s because the game is not in progress": [
    null,
    "La apuesta no es elegible a %1$s ya que el juego no está en curso"
  ],
  "Bet is not eligible for %1$s because the match starts in over 48 hours": [
    null,
    "La apuesta no es elegible a la %1$s ya que el partido comienza en más de 48 h"
  ],
  "Bet is not eligible for %1$s because this version of the game has ended": [
    null,
    "La apuesta no es elegible a la %1$s ya que esta versión del juego ha terminado"
  ],
  "Bet is not eligible for %1$s because you have a reward to collect in order to unlock the next gift": [
    null,
    "La apuesta no es elegible a la %1$s ya que tienes una recompensa a recuperar para desbloquear el próximo regalo"
  ],
  "Bet is not eligible for %1$s because you have already placed an eligible bet on the same match": [
    null,
    "La apuesta no es elegible a la %1$s ya que ya has realizado una apuesta elegible al mismo partido"
  ],
  "Bet is not eligible for %1$s because you have already won the gift": [
    null,
    "La apuesta no es elegible a la %1$s ya que ya te has llevado el regalo"
  ],
  "Bet is not eligible for %1$s because you have not started the game": [
    null,
    "La apuesta no es elegible a la %1$s ya que todavía no has comenzado el juego"
  ],
  "Bet is not eligible for %1$s because you must start the gift quest again": [
    null,
    "La apuesta no es elegible a la %1$s porque tienes que recomenzar la búsqueda del regalo"
  ],
  "Bet is not eligible for %1$s because your current bets will be decisive": [
    null,
    "La apuesta no es elegible a la %1$s ya que tus apuestas en curso serán decisivas"
  ],
  "Bet is not eligible for Boom %1$s": [
    null,
    "La apuesta no es elegible para Boom %1$s"
  ],
  "Bet is not eligible for Boom %1$s because at least one match starts after the end of the game": [
    null,
    "La apuesta no es elegible para Boom %1$s ya que al menos un partido empieza tras el final del juego"
  ],
  "Bet is not eligible for Boom %1$s because system bets are not eligible": [
    null,
    "La apuesta no es elegible para Boom %1$s ya que las apuestas sistema no son elegibles"
  ],
  "Bet is not eligible for Boom %1$s because the game is not in progress": [
    null,
    "La apuesta no es elegible para Boom %1$s ya que el juego no está en curso"
  ],
  "Bet is not eligible for Boom %1$s because the match starts in over 48 hours": [
    null,
    "La apuesta no es elegible para Boom %1$s ya que el partido comienza en más de 48 h"
  ],
  "Bet is not eligible for Boom %1$s because you have a bet in the validation process": [
    null,
    "Tu apuesta no es elegible para Boom %1$s porque ya tienes una apuesta en curso"
  ],
  "Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match": [
    null,
    "La apuesta no es elegible para Boom %1$s ya que ya has realizado una apuesta elegible al mismo partido"
  ],
  "Bet is not eligible for Boom %1$s because you have not started the game": [
    null,
    "La apuesta no es elegiblepara Boom %1$s ya que todavía no has comenzado el juego"
  ],
  "Bet is not eligible for Monopoly": [
    null,
    "La apuesta no es elegible para Monopoly"
  ],
  "Bet is not eligible for Monopoly because at least one match starts after the end of the game": [
    null,
    "La apuesta no es elegible para Monopoly ya que al menos un partido empieza tras el final del juego"
  ],
  "Bet is not eligible for Monopoly because system bets are not eligible": [
    null,
    "La apuesta no es elegible para Monopoly ya que las apuestas sistema no son elegibles"
  ],
  "Bet is not eligible for Monopoly because the game is not in progress": [
    null,
    "La apuesta no es elegible para Monopoly ya que el juego no está en curso"
  ],
  "Bet is not eligible for Monopoly because the match starts in over 48 hours": [
    null,
    "La apuesta no es elegible para Monopoly ya que el partido comienza en más de 48 h"
  ],
  "Bet is not eligible for Monopoly because you have already placed an eligible bet on the same match": [
    null,
    "La apuesta no es elegible para Monopoly ya que ya has realizado una apuesta elegible al mismo partido"
  ],
  "Bet is not eligible for Monopoly because you have not started the game": [
    null,
    "La apuesta no es elegiblepara Monopoly ya que todavía no has comenzado el juego"
  ],
  "Bet modification unavailable": [
    null,
    "No se puede modificar la apuesta"
  ],
  "Bet modification unavailable with free bets": [
    null,
    "Las apuestas gratis no se pueden modificar"
  ],
  "Bet pending": [
    null,
    "Apuesta en espera"
  ],
  "Bet refused": [
    null,
    "Apuesta rechazada"
  ],
  "Bet stopped": [
    null,
    "Apuesta finalizada"
  ],
  "Bet suspended": [
    null,
    "Apuesta suspendida"
  ],
  "Bet tax free": [
    null,
    ""
  ],
  "Bet validated": [
    null,
    "Apuesta validada"
  ],
  "Bet validated!": [
    null,
    "¡Apuesta validada!"
  ],
  "Bet validation in progress": [
    null,
    "Tu apuesta está siendo validada"
  ],
  "Bets on the competition": [
    null,
    "Apuestas a la competición"
  ],
  "Betslip": [
    null,
    "Cesta"
  ],
  "Betting with Winamax": [
    null,
    "Apuesta online con Winamax"
  ],
  "Biggest accumulators": [
    null,
    "Las mejores combinadas"
  ],
  "Biggest winnings": [
    null,
    "Mayores ganancias"
  ],
  "Blocks": [
    null,
    "Tapones"
  ],
  "Boom %1$s internal error": [
    null,
    "Error interno para Boom %1$s"
  ],
  "Boom St Valentine": [
    null,
    "Boom San Valentín"
  ],
  "Borussia M'Gladbach": [
    null,
    "Borussia M'Gladbach"
  ],
  "Both teams": [
    null,
    "Los dos equipos"
  ],
  "Bracket": [
    null,
    "Cuadro de crucres"
  ],
  "Bravo!": [
    null,
    "¡Vamos!"
  ],
  "By ticking this box, your grid will be made private.": [
    null,
    "-"
  ],
  "Cancelled": [
    null,
    "Anulada"
  ],
  "Cashout": [
    null,
    "Cashout"
  ],
  "Cashout (max %1$s)": [
    null,
    "Cashout (máx %1$s)"
  ],
  "Cashout validated": [
    null,
    "Cashout validado"
  ],
  "Cashout validation in progress": [
    null,
    "Cashout en proceso de validación"
  ],
  "Cashout €%1$s": [
    null,
    "Cashout %1$s €"
  ],
  "Cashout: %2$s available": [
    "Cashout: %2$s available",
    "Cashout: %2$s disponible",
    "Cashout: %2$s disponibles"
  ],
  "Certain data may not be up to date.": [
    null,
    "Algunos datos pueden no estar actualizados."
  ],
  "Check out the public grids as well as information about the authors of these grids and find the one that suits you best.": [
    null,
    "-"
  ],
  "Check the full rules": [
    null,
    "Descubre el reglamento"
  ],
  "Choose the amount of your stake on this grid as a team.": [
    null,
    "-"
  ],
  "Choose your format (7 or 12 matches) and validate your own grid.": [
    null,
    "-"
  ],
  "Christmas is already over!": [
    null,
    "La Navidad ya se ha terminado"
  ],
  "Claim": [
    null,
    "Recuperar"
  ],
  "Click and hold an image to save or share": [
    null,
    "Mantén el dedo apoyado sobre la imagen para guardarla o compartirla"
  ],
  "Close": [
    null,
    "Cerrar"
  ],
  "Close details": [
    null,
    "Cerrar detalles"
  ],
  "Combinations": [
    null,
    "Combinaciones"
  ],
  "Combo booster": [
    null,
    "Combo booster"
  ],
  "Compact grid": [
    null,
    "-"
  ],
  "Compact view": [
    null,
    "Vista compacta"
  ],
  "Competitions": [
    null,
    "Competiciones"
  ],
  "Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:": [
    null,
    "Supera las 3 fases del juego encadenando las apuestas ganadoras y llévate regalos legendarios y un montón de Freebets"
  ],
  "Complete bet": [
    null,
    "Completar mi apuesta"
  ],
  "Confirm": [
    null,
    "Validar"
  ],
  "Congratulations on your journey!": [
    null,
    "¡Enhorabuena por tu victoria!"
  ],
  "Congratulations!": [
    null,
    "¡Felicidades!"
  ],
  "Connection error.": [
    null,
    "Error de conexión."
  ],
  "Contradictory selections": [
    null,
    "Selecciones contradictorias"
  ],
  "Contradictory selections.": [
    null,
    "Las selecciones son contradictorias."
  ],
  "Contradictory selections. Check your betslip.": [
    null,
    "Las selecciones son contradictorias. Verifica la cesta."
  ],
  "Copied": [
    null,
    "Copiado"
  ],
  "Copy": [
    null,
    "Copiar"
  ],
  "Copy the link": [
    null,
    "Copiar el enlace"
  ],
  "Countries": [
    null,
    "Países"
  ],
  "Dead-Heat": [
    null,
    "Caso de empate"
  ],
  "Decisive": [
    null,
    "Decisivo"
  ],
  "Decisive players": [
    null,
    "Jugadores decisivos"
  ],
  "Delete grid": [
    null,
    "-"
  ],
  "Delete my favourites": [
    null,
    "Eliminar mis favoritos"
  ],
  "Detailed grids": [
    null,
    "-"
  ],
  "Didn't understand everything on the previous screen?": [
    null,
    "¿No entendiste todo en la pantalla anterior?"
  ],
  "Direct free kick": [
    null,
    "Tiro libre directo"
  ],
  "Display sliders on relevant bets by default": [
    null,
    "Mostrar por defecto el cursor en las apuestas relevantes"
  ],
  "Do you like this application?": [
    null,
    "¿Te gusta esta aplicación?"
  ],
  "Do you want to keep a low profile and only share your grid with your friends? Opt for the private grid.": [
    null,
    "-"
  ],
  "Do you wish to comment on this application?": [
    null,
    "¿Deseas dejar un comentario sobre esta aplicación?"
  ],
  "Don't save bet": [
    null,
    "No guardar más la apuesta"
  ],
  "Double-double": [
    null,
    "Doble-doble"
  ],
  "Draw": [
    null,
    "Empate"
  ],
  "Duplicate grid": [
    null,
    "-"
  ],
  "Each simple bet is placed individually": [
    null,
    "Toda apuesta simple debe ser única"
  ],
  "Edit": [
    null,
    "Editar"
  ],
  "Enhance": [
    null,
    "Completar"
  ],
  "Error whilst crediting your reward": [
    null,
    "Error durante la distribución de tu recompensa"
  ],
  "Error, please try again": [
    null,
    "Error, inténtalo de nuevo por favor"
  ],
  "Event abandoned": [
    null,
    "Evento abandonado"
  ],
  "Event cancelled": [
    null,
    "Evento anulado"
  ],
  "Event ended": [
    null,
    "Evento terminado"
  ],
  "Event postponed": [
    null,
    "Evento aplazado"
  ],
  "Eventual winnings will be shared in proportion to each player's stake.": [
    null,
    "Las posibles ganancias se repartirán de forma proporcional al importe apostado por cada participante."
  ],
  "Excluding extra-time and penalty shoot-out.": [
    null,
    "Eventuales prórrogas y tandas de penaltis no incluidas."
  ],
  "Explode Cupid by winnings 5 bets": [
    null,
    "Explota a Cupido ganando 5 apuestas"
  ],
  "Explode the leprechaun by winnings 5 bets": [
    null,
    "Explota al leprechaun ganando 5 apuestas"
  ],
  "Explode your pumpkin by winnings 5 bets": [
    null,
    "Explota la calabaza ganando 5 apuestas"
  ],
  "Extras": [
    null,
    "Promos"
  ],
  "FC Porto": [
    null,
    "FC Porto"
  ],
  "Filter bets": [
    null,
    "Filtrar apuestas"
  ],
  "Finance your entire grid or share the jackpot by playing as a team.": [
    null,
    "-"
  ],
  "Find out how much you've pocketed as soon as the last game of your grid ends.": [
    null,
    "-"
  ],
  "First": [
    null,
    "Primer"
  ],
  "Flash": [
    null,
    "Flash"
  ],
  "Follow the live results and stats of your grids.": [
    null,
    "-"
  ],
  "For a 24h break hold the button pressed for 3 seconds.": [
    null,
    ""
  ],
  "Format change": [
    null,
    "Cambio de formato"
  ],
  "Frame %1$s": [
    null,
    "Frame %1$s"
  ],
  "Freebet Wager": [
    null,
    "Apuesta Freebets"
  ],
  "Freebet win for the complete colour collection: Reference bet x %1$s": [
    null,
    "Ganancia en Freebets asociada al grupo de color completado: apuesta de referencia x %1$s"
  ],
  "Freebet winnings if you win this level: Reference bet x %1$s": [
    null,
    "Ganancia en Freebets si consigues este nivel: Apuesta de referencia x %1$s"
  ],
  "Freebets Wager": [
    null,
    "Apuesta Freebets"
  ],
  "Game objective": [
    null,
    "Objetivo del juego"
  ],
  "Gather properties, complete colour collections and win lots of Freebets!": [
    null,
    "¡Llévate las propiedades, completa los grupos de color y consigue un máximo de Freebets! "
  ],
  "General problem": [
    null,
    "Problema general"
  ],
  "Get started": [
    null,
    "Comenzar"
  ],
  "Gift Race": [
    null,
    "Lluvia de regalos"
  ],
  "Goalscorer Duo": [
    null,
    "Duo Goleadores"
  ],
  "Goalscorer Guarantee": [
    null,
    "Cambio en la 1ª mitad"
  ],
  "Goalscorer Trio": [
    null,
    "Trío Goleadores"
  ],
  "Goalscorer in a period": [
    null,
    "Goleador durante uno de los periodos"
  ],
  "Goalscorers in a 10 min period": [
    null,
    "Goleador en un periodo de 10 min"
  ],
  "Goalscorers in a 15 min period": [
    null,
    "Goleador en un periodo de 15 min"
  ],
  "Graphics preferences": [
    null,
    "Preferencias gráficas"
  ],
  "Grid": [
    null,
    "Quiniela"
  ],
  "Grid %1$s winnings": [
    null,
    "-"
  ],
  "Grid price": [
    null,
    "-"
  ],
  "Grid result": [
    null,
    "-"
  ],
  "Grids": [
    null,
    "-"
  ],
  "Grids Home": [
    null,
    "-"
  ],
  "Guarantee:": [
    null,
    "Garantizado:"
  ],
  "Half time - Multiple goalscorers": [
    null,
    "1ª mitad - Goleadores múltiples"
  ],
  "Half-time goalscorers": [
    null,
    "Goleador en una mitad"
  ],
  "Halloween": [
    null,
    "Halloween"
  ],
  "Header": [
    null,
    "Cabeza"
  ],
  "Hidden": [
    null,
    "Ocultas"
  ],
  "Hide bet": [
    null,
    "Ocultar la apuesta"
  ],
  "Highest MyMatch odds": [
    null,
    "Las mejores cuotas MyMatch"
  ],
  "Highest odds": [
    null,
    "Las mejores cuotas"
  ],
  "Home": [
    null,
    "Inicio"
  ],
  "Hunting": [
    null,
    "Hunting"
  ],
  "Hunting All-Stars": [
    null,
    "Hunting All-Stars"
  ],
  "If you lose a bet, you start the phase from 0.": [
    null,
    "Si pierdes una apuesta, comenzarás de 0 en esta fase."
  ],
  "Important account information": [
    null,
    "Información sobre tu cuenta"
  ],
  "In Play": [
    null,
    "LIVE"
  ],
  "In progress": [
    null,
    "En curso"
  ],
  "Incorrect PIN": [
    null,
    "Código pin incorrecto"
  ],
  "Incorrect amount": [
    null,
    "Cantidad incorrecta"
  ],
  "Incorrect email, password or date of birth": [
    null,
    "El correo electrónico o la contraseña son incorrectos"
  ],
  "Individual grid": [
    null,
    "-"
  ],
  "Inter Milan": [
    null,
    "Inter Milán"
  ],
  "Internal error": [
    null,
    "Error interno"
  ],
  "It's not the grids that matter, it's what you do with them!": [
    null,
    "-"
  ],
  "It's simple! Select a result of your choice (team 1 or team 2 or draw) for each match.": [
    null,
    "¡Es muy sencillo! Selecciona un resultado (equipo 1, empate o equipo 2) para cada partido"
  ],
  "Koh-Lanta": [
    null,
    "Koh-Lanta"
  ],
  "Lacking inspiration? You can also take part in a public grid.": [
    null,
    "-"
  ],
  "Last": [
    null,
    "Último"
  ],
  "Later": [
    null,
    "Más tarde"
  ],
  "Least expensive": [
    null,
    "Más baratas"
  ],
  "Less selections": [
    null,
    "Menos selecciones"
  ],
  "Level %1$s": [
    null,
    "Nivel %1$s"
  ],
  "Line %1$s": [
    null,
    "Línea %1$s"
  ],
  "Link copied!": [
    null,
    "¡Enlace copiado!"
  ],
  "Live": [
    null,
    "En directo"
  ],
  "Liverpool": [
    null,
    "Liverpool"
  ],
  "Loading": [
    null,
    "Cargando"
  ],
  "Loading in progress": [
    null,
    "Cargando..."
  ],
  "Log in": [
    null,
    "Conectarse"
  ],
  "Log in to %1$s": [
    null,
    "Conectarte a %1$s"
  ],
  "Lost": [
    null,
    "Perdida"
  ],
  "Maintenance in progress": [
    null,
    "Mantenimiento en curso"
  ],
  "Maintenance in progress.": [
    null,
    "Mantenimiento en curso."
  ],
  "Manchester City": [
    null,
    "Manchester City"
  ],
  "Manchester United": [
    null,
    "Manchester United"
  ],
  "Map %1$s": [
    null,
    "Mapa %1$s"
  ],
  "Marseille": [
    null,
    "O.Marsella"
  ],
  "Match": [
    null,
    "Partido"
  ],
  "Match details": [
    null,
    "Detalles de los partidos"
  ],
  "Match details and odds": [
    null,
    "Detalles del partido y cuotas"
  ],
  "Match ended": [
    null,
    "Partido terminado"
  ],
  "Match odds": [
    null,
    "Las cuotas del partido"
  ],
  "Match result odds": [
    null,
    "Cuotas del resultado del partido"
  ],
  "Match unavailable": [
    null,
    "Partido no disponible"
  ],
  "Matches": [
    null,
    "Partidos"
  ],
  "Maximum selections reached": [
    null,
    "Has alcanzado el número máximo de selecciones"
  ],
  "Min. odds": [
    null,
    "Cuota mín."
  ],
  "Min. odds:": [
    null,
    "Cuota mín."
  ],
  "Min. wager:": [
    null,
    "Apuesta mín."
  ],
  "Minimum odds to win this card: %1$s": [
    null,
    "Cuota mínima para ganar esta carta: %1$s"
  ],
  "Minimum odds to win this level: %1$s": [
    null,
    "Cuota mínima para conseguir este nivel: %1$s"
  ],
  "Monopoly internal error": [
    null,
    "Error interno para Monopoly"
  ],
  "More selections": [
    null,
    "Más selecciones"
  ],
  "Most advanced": [
    null,
    "Más avanzadas"
  ],
  "Most expensive": [
    null,
    "Más caras"
  ],
  "Most popular": [
    null,
    "Más populares"
  ],
  "Most recent": [
    null,
    "Más recientes"
  ],
  "Multiples:": [
    null,
    "Combinadas:"
  ],
  "Multiscorers": [
    null,
    "Goleadores múltiples"
  ],
  "My bets": [
    null,
    "Mis apuestas"
  ],
  "My collection": [
    null,
    "Mi colección"
  ],
  "My favourites": [
    null,
    "Mis favoritos"
  ],
  "My grids": [
    null,
    "-"
  ],
  "My wager": [
    null,
    "Mi apuesta"
  ],
  "My winnings": [
    null,
    "Mis ganancias"
  ],
  "MyMatch currently unavailable": [
    null,
    "MyMatch no disponible en este momento."
  ],
  "MyMatch mode": [
    null,
    "Modo MyMatch"
  ],
  "MyMatch unavailable": [
    null,
    "MyMatch no está disponible"
  ],
  "News": [
    null,
    "News"
  ],
  "Next": [
    null,
    "Siguiente"
  ],
  "Next grid": [
    null,
    "-"
  ],
  "Next grids": [
    null,
    "-"
  ],
  "No": [
    null,
    "No"
  ],
  "No bets": [
    null,
    "Ninguna apuesta"
  ],
  "No grid": [
    null,
    "-"
  ],
  "No grid played": [
    null,
    "-"
  ],
  "No grids": [
    null,
    "-"
  ],
  "No grids cancelled": [
    null,
    "-"
  ],
  "No grids lost": [
    null,
    "-"
  ],
  "No grids running": [
    null,
    "-"
  ],
  "No grids won": [
    null,
    "-"
  ],
  "No public grids": [
    null,
    "-"
  ],
  "No rank 1 winners": [
    null,
    "No hay ganadores de categoría 1"
  ],
  "No results": [
    null,
    "Ningún resultado"
  ],
  "No team": [
    null,
    "Ningún equipo"
  ],
  "Non-top 10 competitor": [
    null,
    "Participante fuera del Top 10"
  ],
  "Non-top 30 competitor": [
    null,
    "Participante fuera del Top 30"
  ],
  "Not enough combinations": [
    null,
    "No has seleccionado las combinaciones suficientes"
  ],
  "Notifications": [
    null,
    "Notificaciones"
  ],
  "Number": [
    null,
    "Número"
  ],
  "Number of bets": [
    null,
    "Número de apuestas "
  ],
  "Number of goals from the player": [
    null,
    "Número de goles del jugador"
  ],
  "Odds": [
    null,
    "Cuota"
  ],
  "Odds equal or inferior to 1": [
    null,
    "Cuota igual o inferior a 1 "
  ],
  "Odds:": [
    null,
    "Cuota:"
  ],
  "Official lineups": [
    null,
    "Alineaciones oficiales"
  ],
  "Official starting lineups": [
    null,
    "5 inicial oficial"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Olympiakos": [
    null,
    "Olympiakos"
  ],
  "One or multiple selections are unavailable": [
    null,
    "Alguna(s) de tus selecciones no está(n) disponible(s)"
  ],
  "Ongoing": [
    null,
    "En curso"
  ],
  "Oops,": [
    null,
    "¡Vaya!"
  ],
  "Open the App Store": [
    null,
    "Abrir la App Store"
  ],
  "PRA": [
    null,
    "PRA"
  ],
  "Paris SG": [
    null,
    "Paris SG"
  ],
  "Penalty": [
    null,
    "Penalti"
  ],
  "Penalty try": [
    null,
    "Try penal"
  ],
  "Pending %1$s bets": [
    null,
    "Apuesta %1$s pendiente"
  ],
  "Pending bet refused": [
    null,
    "Apuesta en espera rechazada"
  ],
  "Pending bet validated": [
    null,
    "Apuesta en espera validada"
  ],
  "Permanent and past promotions": [
    null,
    "Ofertas permanentes y pasadas"
  ],
  "Phase 1: Pegasus Shoes": [
    null,
    "Fase 1: las botas de Hermes"
  ],
  "Phase 2: The remote control ball": [
    null,
    "Fase 2: el balón teledirigido"
  ],
  "Phase 3: The Chameleon Jersey": [
    null,
    "Fase 3: la camiseta camaleónica"
  ],
  "Place a series of winning bets to score %1$s points.": [
    null,
    "Encadena las apuestas ganadoras para sumar %1$s puntos."
  ],
  "Play the game to try and win a ton of Freebets!": [
    null,
    "¡Participa en el juego para intentar\nganar el máximo de Freebets!"
  ],
  "Player": [
    null,
    "Jugador"
  ],
  "Player vs. player": [
    null,
    "Jugador contra jugador"
  ],
  "Player vs. team": [
    null,
    "Jugador contra equipo"
  ],
  "Please enter a valid amount.": [
    null,
    "Por favor, introduce una cantidad válida."
  ],
  "Please enter your date of birth": [
    null,
    "Por favor, introduce tu fecha de nacimiento"
  ],
  "Points": [
    null,
    "Puntos"
  ],
  "Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.": [
    null,
    "Baremo de puntos: cuotas ganadoras * 100. Por tanto, si tus 3 primeras apuestas son ganadoras, obtendrás los siguientes puntos: cuota de la 1ª * cuota de la 2ª * cuota de la 3ª * 100."
  ],
  "Points+assists": [
    null,
    "Puntos+Asistencias"
  ],
  "Points+rebounds": [
    null,
    "Puntos+rebotes"
  ],
  "Poker": [
    null,
    "Poker"
  ],
  "Potential winnings": [
    null,
    "Ganancias potenciales "
  ],
  "Previous": [
    null,
    "Anterior"
  ],
  "Prize distribution per player": [
    null,
    "Distribución de premios por jugador"
  ],
  "Prizepool": [
    null,
    "Dotación"
  ],
  "Probable starting lineups": [
    null,
    "5 inicial probable"
  ],
  "Prohibited": [
    null,
    "No autorizado"
  ],
  "Prohibited (no-stakes game)": [
    null,
    "No autorizado (partido sin aliciente)"
  ],
  "Projected lineups": [
    null,
    "Alineaciones probables"
  ],
  "Provisional grid result": [
    null,
    "-"
  ],
  "Provisional prize distribution": [
    null,
    "Distribución provisional de premios"
  ],
  "Public grid": [
    null,
    "-"
  ],
  "Public grids": [
    null,
    "-"
  ],
  "Real Madrid": [
    null,
    "Real Madrid"
  ],
  "Rebounds": [
    null,
    "Rebotes"
  ],
  "Ref:": [
    null,
    "Ref:"
  ],
  "Reference": [
    null,
    "Referencia"
  ],
  "Reference bet: the smallest bet of the levels you have won (max %1$s)": [
    null,
    "Apuesta de referencia: el importe más pequeño apostado en los niveles conseguidos (máx. %1$s)"
  ],
  "Refuse": [
    null,
    "Rechazar"
  ],
  "Refused": [
    null,
    "Rechazada"
  ],
  "Repeat this bet": [
    null,
    "Rehacer esta apuesta"
  ],
  "Reset": [
    null,
    "Reiniciar"
  ],
  "Reset the grid": [
    null,
    "-"
  ],
  "Result": [
    null,
    "Resultado"
  ],
  "Retired or defaulted": [
    null,
    "Abandono o descalificación"
  ],
  "Reviews": [
    null,
    "Opiniones"
  ],
  "Right-click an image to copy it or to save it on your device": [
    null,
    "Haz clic con el botón derecho del ratón sobre una imagen para copiarla o guardarla en tu dispositivo."
  ],
  "Rules": [
    null,
    "Reglamento"
  ],
  "Running": [
    null,
    "En curso"
  ],
  "Save bet": [
    null,
    "Guardar apuesta"
  ],
  "Save my selection": [
    "Save my selections",
    "Conservar mi selección",
    "Conservar mis selecciones"
  ],
  "Saved": [
    null,
    "Registradas"
  ],
  "Scan a bonus code": [
    null,
    "Escanear un código bono"
  ],
  "Scorer": [
    null,
    "Goleador"
  ],
  "Scorer type": [
    null,
    "Tipo de gol del jugador"
  ],
  "Scorers": [
    null,
    "Goleadores"
  ],
  "Search": [
    null,
    "Buscar"
  ],
  "See all": [
    null,
    "Ver todo"
  ],
  "See all odds": [
    null,
    "Ver todas las cuotas"
  ],
  "See details": [
    null,
    "Detalles"
  ],
  "See more selections": [
    null,
    "Ver más selecciones"
  ],
  "See top matches": [
    null,
    "Ver partidos destacados"
  ],
  "Select": [
    null,
    "Seleccionar"
  ],
  "Service unavailable": [
    null,
    "Servicio no disponible"
  ],
  "Settings": [
    null,
    "Parámetros"
  ],
  "Shaktar Donetsk": [
    null,
    "Shaktar Donetsk"
  ],
  "Share bet to a friend's basket": [
    null,
    "Compartir la apuesta a la cesta de un amigo"
  ],
  "Share image": [
    null,
    "Compartir la imagen"
  ],
  "Share my bet": [
    null,
    "Compartir mi apuesta"
  ],
  "Share options": [
    null,
    "Opciones de compartir"
  ],
  "Shop": [
    null,
    "Tienda"
  ],
  "Show animation when adding a selection to betslip": [
    null,
    "Mostrar una animación cada vez que se añada una selección a la cesta"
  ],
  "Show bet": [
    null,
    "No ocultar más la apuesta"
  ],
  "Show username": [
    null,
    "Mostrar nombre de usuario"
  ],
  "Show wager and winnings": [
    null,
    "Mostrar apuesta y ganancias"
  ],
  "Sign-in": [
    null,
    "Conectarse"
  ],
  "Sign-in and place bet": [
    null,
    "Conéctate y apuesta"
  ],
  "Sign-up": [
    null,
    "Inscribirse"
  ],
  "Simple touchdown scorer": [
    null,
    "Anotador"
  ],
  "Single": [
    null,
    "Simple"
  ],
  "Skip all": [
    null,
    "Saltar todo"
  ],
  "Sports": [
    null,
    "Deportes"
  ],
  "Sports bets": [
    null,
    "Apuestas deportivas"
  ],
  "St Patrick": [
    null,
    "St Patrick"
  ],
  "St Valentine": [
    null,
    "San Valentín"
  ],
  "Start": [
    null,
    "Empezar"
  ],
  "Start again": [
    null,
    "Recomenzar"
  ],
  "Starter": [
    null,
    "Titular"
  ],
  "Starters": [
    null,
    "Titulares"
  ],
  "Starting 5 Guarantee": [
    null,
    "5 inicial juega menos 12 minutos"
  ],
  "Stats": [
    null,
    "Estadísticas"
  ],
  "Steals": [
    null,
    "Robos"
  ],
  "Steals+blocks": [
    null,
    "Robos+tapones"
  ],
  "Substitutes": [
    null,
    "Suplentes"
  ],
  "System": [
    null,
    "Sistema"
  ],
  "System %1$s": [
    null,
    "Sistema %1$s"
  ],
  "System %1$s/%2$s": [
    null,
    "Sistema %1$s/%2$s"
  ],
  "System bet": [
    null,
    "Apuesta sistema"
  ],
  "System grid": [
    null,
    "-"
  ],
  "System grid price": [
    null,
    "-"
  ],
  "Take part": [
    null,
    "Participar"
  ],
  "Team 1": [
    null,
    "Equipo 1"
  ],
  "Team 2": [
    null,
    "Equipo 2"
  ],
  "Team grid": [
    null,
    "-"
  ],
  "Terms and Conditions and Privacy Policy": [
    null,
    "Términos y condiciones y Política de privacidad"
  ],
  "The Gift Race": [
    null,
    "Lluvia de regalos"
  ],
  "The Pegasus shoes to fly over your next match": [
    null,
    "Las botas de Hermes para sobrevolar tu próximo partido"
  ],
  "The bet is not eligible for Boom %1$s because Freebets are not taken into account": [
    null,
    "Tu apuesta no es elegible para Boom %1$s porque las apuestas con Freebets no se tienen en cuenta"
  ],
  "The bet is not eligible for Monopoly because Freebets are not taken into account": [
    null,
    "Las apuestas realizadas con Freebets no son elegibles para la promoción Monopoly"
  ],
  "The chameleon jersey to change teams in a flash": [
    null,
    "La camiseta camaleónica para cambiar de equipo en un visto y no visto"
  ],
  "The classic accumulator wins if the %1$s are correct": [
    null,
    "La combinada clásica: ganarás si aciertas las %1$s"
  ],
  "The date of birth entered does not match the date registered on your account": [
    null,
    "La fecha de nacimiento introducida no coincide"
  ],
  "The date of birth you have entered is invalid": [
    null,
    "La fecha de nacimiento introducida no es válida"
  ],
  "The game is over": [
    null,
    "Se ha terminado el juego"
  ],
  "The game will end in under 24 hours": [
    null,
    "El juego terminará en menos de 24 horas"
  ],
  "The hunt is over": [
    null,
    "La caza ha terminado"
  ],
  "The maximum stake for this bet has already been reached, or the stake is lower than the minimum of €0.10": [
    null,
    "El importe máximo para esta apuesta ya ha sido alcanzado o es inferior al importe mínimo (0,10 €)"
  ],
  "The maximum wager is %1$s": [
    null,
    "La apuesta máxima es %1$s"
  ],
  "The minimum odds are %1$s": [
    null,
    "La cuota mínima es %1$s"
  ],
  "The minimum wager is %1$s": [
    null,
    "La apuesta mínima es %1$s"
  ],
  "The odds have changed": [
    null,
    "La cuota ha cambiado"
  ],
  "The prize for this collection has already been claimed": [
    null,
    "Ya has recuperado el premio asociado a esta colección"
  ],
  "The remote-controlled ball with its unpredictable trajectories": [
    null,
    "El balón teledirigido con sus trayectorias impredecibles"
  ],
  "The service is currently unavailable. We will restore this as soon as possible. We apologise for any inconveniences caused by this.": [
    null,
    "El servicio no está disponible momentáneamente y se reestablecerá lo antes posible. Perdón por las molestias."
  ],
  "The system grid is an expert mode. It allows you to create complex grids with some basic matches.": [
    null,
    "-"
  ],
  "The video could not be loaded as it is an unsupported video format or due to a server issue.": [
    null,
    "El vídeo no se ha podido cargar a causa de un formato no aceptado o un error en el servidor."
  ],
  "This QR code is not a Winamax bonus code": [
    null,
    "Este código QR no es un código bono Winamax"
  ],
  "This broadcast is not available in your country of residence.": [
    null,
    "La difusión de este vídeo no está autorizada en tu país."
  ],
  "This code is not a Winamax bonus code or has already been credited": [
    null,
    "Este código no es un código bonus Winamax o ya ha sido utilizado"
  ],
  "This event is no longer available": [
    null,
    "El evento ya no está disponible"
  ],
  "This free bet cannot be used": [
    null,
    "No puedes usar esta apuesta gratis"
  ],
  "This match is already included in the betslip you wish to enhance.": [
    null,
    "Este partido ya está incluido en la apuesta que deseas completar."
  ],
  "This promotion has ended": [
    null,
    "Esta promoción ha finalizado"
  ],
  "This promotion will end in under 24 hours": [
    null,
    "Esta promoción finalizará en menos de 24 horas"
  ],
  "This version of the software is not supported": [
    null,
    "Versión del software no soportada"
  ],
  "This video could not be loaded as it has unsupported functionalities.": [
    null,
    "El vídeo no se ha podido cargar a causa de una funcionalidad no tomada en cuenta."
  ],
  "Three-pointers": [
    null,
    "Triples"
  ],
  "Tick the boxes in your grid.": [
    null,
    "-"
  ],
  "To be won": [
    null,
    "A ganar"
  ],
  "Tomorrow": [
    null,
    "Mañana"
  ],
  "Too many attempts.": [
    null,
    "Demasiados intentos."
  ],
  "Too many bankers": [
    null,
    "Demasiadas apuestas banker"
  ],
  "Too many bets selected": [
    null,
    "Demasiadas apuestas seleccionadas"
  ],
  "Too many selections": [
    null,
    "Demasiadas selecciones"
  ],
  "Top competitions": [
    null,
    "Competiciones destacadas"
  ],
  "Total": [
    null,
    "Total"
  ],
  "Total away": [
    null,
    "Total a domicilio"
  ],
  "Total home": [
    null,
    "Total local"
  ],
  "Total odds": [
    null,
    "Cuota total"
  ],
  "Total wager": [
    null,
    "Importe total"
  ],
  "Total winnings": [
    null,
    "Ganancias totales "
  ],
  "Touchdowns scorers": [
    null,
    "Anotadores de touchdowns"
  ],
  "Triple-double": [
    null,
    "Triple-doble"
  ],
  "Try again": [
    null,
    "Reintentar"
  ],
  "Try scorer Duo": [
    null,
    "Duo Anotadores de ensayo"
  ],
  "Try scorer Trio": [
    null,
    "Trio Anotadores de ensayo"
  ],
  "Try scorers": [
    null,
    "Anotadores de ensayos"
  ],
  "Try:": [
    null,
    "Intentar:"
  ],
  "Turnovers": [
    null,
    "Pérdidas"
  ],
  "Tutorial": [
    null,
    "Tutorial"
  ],
  "Type of goal scored by a team": [
    null,
    "Tipo de gol de un equipo"
  ],
  "Unable to calculate odds": [
    null,
    "No se puede calcular la cuota"
  ],
  "Upcoming matches": [
    null,
    "Próximos partidos (calendario)"
  ],
  "Update": [
    null,
    "Actualización"
  ],
  "Use Freebets": [
    null,
    "Utilizar Freebets"
  ],
  "Use a bonus": [
    null,
    "Utilizar un bono"
  ],
  "Video unavailable": [
    null,
    "Vídeo no disponible."
  ],
  "View my bet": [
    null,
    "Ver mi apuesta"
  ],
  "View the most wagered bets in the last %1$s mins": [
    null,
    "Descubre las apuestas más populares de los últimos %1$s min"
  ],
  "View the most wagered bets in the last hour": [
    null,
    "Descubre las apuestas más populares de la última hora"
  ],
  "Wager": [
    null,
    "Importe"
  ],
  "Wager:": [
    null,
    "Importe:"
  ],
  "Walkover": [
    null,
    ""
  ],
  "Want another accumulator? Switch to MyMatch!": [
    null,
    "¿No encuentras lo que buscas? Pásate al modo MyMatch"
  ],
  "Want another multi-chance accumulator? Switch to MyMatch!": [
    null,
    "¿No encuentras lo que buscas? Pásate al modo MyMatch"
  ],
  "Want to check out all the promotions Winamax has to offer?": [
    null,
    "¿Quieres conocer todo lo que podemos ofrecerte?"
  ],
  "Warning:": [
    null,
    "Atención:"
  ],
  "We were unable to generate your final image": [
    null,
    "No hemos podido generar tu imagen final."
  ],
  "We'll explain everything step by step!": [
    null,
    "¡Te explicaremos todo paso a paso!"
  ],
  "Welcome to the grid tutorial": [
    null,
    "-"
  ],
  "Win a ton of Freebets along the way!": [
    null,
    "y ¡consigue el máximo de Freebets!"
  ],
  "Win all previous levels in order to unlock this level": [
    null,
    "Consigue los niveles anteriores para poder desbloquear este nivel"
  ],
  "Win up to": [
    null,
    "Gana hasta"
  ],
  "Win up to %1$s times your reference bet in Freebets!": [
    null,
    "Gana hasta %1$s veces tu apuesta de referencia en Freebets"
  ],
  "WinaTV channel": [
    null,
    "Canal WinaTV"
  ],
  "Winamax QR code": [
    null,
    "Código QR Winamax"
  ],
  "Winamax grid": [
    null,
    "-"
  ],
  "Winning is everything": [
    null,
    "Lo más importante es ganar"
  ],
  "Winnings": [
    null,
    "Ganancias"
  ],
  "Winnings %1$s": [
    null,
    "Ganancias %1$s"
  ],
  "Winnings inferior or equal to the wager": [
    null,
    "Ganancias inferiores o iguales a la apuesta"
  ],
  "Won": [
    null,
    "Ganada"
  ],
  "Xmas": [
    null,
    "Navidad"
  ],
  "Yes": [
    null,
    "Sí"
  ],
  "You aborted the media playback.": [
    null,
    "Has interrumpido la reproducción del vídeo."
  ],
  "You are currently excluded from %1$s due to your game limits": [
    null,
    "Actualmente estás excluído de la %1$s en tus límites de juego"
  ],
  "You are currently excluded from Monopoly due to your game limits": [
    null,
    "Actualmente estás excluído para Monopoly en tus límites de juego"
  ],
  "You are currently excluded from betting promotions in your %1$s": [
    null,
    "Actualmente no puedes participar en las promociones. Para ello, deberás aceptar de forma expresa tu participación %1$s."
  ],
  "You are currently ineligible for %1$s": [
    null,
    "Actualmente no eres elegible a la %1$s"
  ],
  "You are currently ineligible for Boom %1$s": [
    null,
    "Actualmente no eres elegible para Boom %1$s"
  ],
  "You are currently ineligible for Monopoly": [
    null,
    "Actualmente no eres elegible para Monopoly"
  ],
  "You are currently not eligible to betting promotions": [
    null,
    "Actualmente no eres elegible a nuestra oferta de apuestas deportivas."
  ],
  "You are not authorized to connect from this country.": [
    null,
    "No estás autorizado a conectarte desde este país."
  ],
  "You can also make doubles or triples to increase your chances of winning": [
    null,
    "También puedes elegir dobles o triples para incrementar tus oportunidades de ganar."
  ],
  "You can also select doubles and triples to have a better chance of winning.": [
    null,
    "También puedes elegir dobles o triples para incrementar tus oportunidades de ganar."
  ],
  "You can do so right here! :index_vers_le_bas:": [
    null,
    "¡Existe un lugar donde descubrirás todo, justo aquí!"
  ],
  "You can select doubles and triples to increase your chances of winning.": [
    null,
    "También puedes elegir dobles o triples para incrementar tus oportunidades de ganar."
  ],
  "You cannot bet on this grid anymore": [
    null,
    "-"
  ],
  "You cannot combine multiple bets on the same match": [
    null,
    "No puedes combinar varias apuestas al mismo partido"
  ],
  "You cannot combine these bets": [
    null,
    "No puedes combinar estas apuestas"
  ],
  "You have already placed the same bet recently": [
    null,
    "Ya has realizado recientemente la misma apuesta"
  ],
  "You have already received your reward": [
    null,
    "Ya has recibido tu recompensa"
  ],
  "You have been active for %1$s minutes now.": [
    null,
    "Has estado jugando durante %1$s minutos."
  ],
  "You have exceeded the maximum stake for this bet": [
    null,
    "Se ha superado la cantidad máxima para esta apuesta"
  ],
  "You have made a request to change your password. Please check your emails.": [
    null,
    "Has solicitado cambiar la contraseña. Por favor, revisa tu bandeja de entrada."
  ],
  "You have no favourites": [
    null,
    "No tienes ningún favorito"
  ],
  "You have no funds in your account.": [
    null,
    "No tienes fondos en tu cuenta."
  ],
  "You lose": [
    null,
    "Perdido"
  ],
  "You may not receive a booster on this bet": [
    null,
    "No recibirás el booster con esta apuesta"
  ],
  "You must be logged": [
    null,
    "Debes estar conectado"
  ],
  "You must be logged in to see this page": [
    null,
    "Debes estar conectado para ver esta página"
  ],
  "You must be logged in to validate your bets": [
    null,
    "Debes estar conectado para validar tu apuesta"
  ],
  "You must be logged in to validate your grid.": [
    null,
    "-"
  ],
  "You must be of majority age to play": [
    null,
    "Debes ser mayor de edad para jugar"
  ],
  "You must have a minimum of €1 on your account, or you must have placed a bet on this match.": [
    null,
    "Debes tener mínimo 1 € en tu cuenta o haber apostado a este partido."
  ],
  "You must log in to %1$s in order to access your account.": [
    null,
    "Debes conectarte a %1$s para acceder a tu cuenta."
  ],
  "You must select doubles or triples to make a team grid.": [
    null,
    "-"
  ],
  "You must tick at least one box per line.": [
    null,
    "Tienes que seleccionar al menos una casilla por línea."
  ],
  "You must wager your deposit in order to withdraw it": [
    null,
    ""
  ],
  "You only have %1$s": [
    null,
    "Solo tienes %1$s"
  ],
  "You only have %1$s in Freebets available": [
    null,
    "Solo tienes %1$s en Freebets disponibles "
  ],
  "You will earn between %1$s and %2$s times your reference bet in Freebets.": [
    null,
    "Ganarás entre %1$s y %2$s veces el valor de tu apuesta de referencia."
  ],
  "You will exceed your daily limit. The maximum wager is %1$s": [
    null,
    "Sobrepasarías tu límite diario. La apuesta máxima es %1$s"
  ],
  "You will exceed your monthly limit. The maximum wager is %1$s": [
    null,
    "Sobrepasarías tu límite mensual. La apuesta máxima es %1$s"
  ],
  "You will exceed your weekly limit. The maximum wager is %1$s": [
    null,
    "Sobrepasarías tu límite semanal. La apuesta máxima es %1$s"
  ],
  "You win": [
    null,
    "Ganada"
  ],
  "You win Freebets": [
    null,
    "Has conseguido Freebets"
  ],
  "You won Freebets": [
    null,
    "Tu premio en Freebets"
  ],
  "You've already won everything!": [
    null,
    "¡Has conseguido todos los regalos!"
  ],
  "Your %1$s bet could not be cashed out": [
    null,
    "No ha sido posible cerrar la apuesta %1$s"
  ],
  "Your %1$s bet has been validated": [
    null,
    "Tu apuesta de %1$s ha sido validada"
  ],
  "Your %1$s bet was cashed out for %2$s": [
    null,
    "Has cerrado la apuesta %1$s por %2$s"
  ],
  "Your account is frozen.": [
    null,
    "Tu cuenta está bloqueada."
  ],
  "Your account is locked": [
    null,
    "Tu cuenta está bloqueada"
  ],
  "Your account is not authorized for use in this region": [
    null,
    "No puedes utilizar tu cuenta desde esta plataforma"
  ],
  "Your app is out of date, please update to the latest version": [
    null,
    "Esta versión de la aplicación está obsoleta. Por favor, actualízala."
  ],
  "Your betslip is empty!": [
    null,
    "¡Tu cesta está vacía!"
  ],
  "Your bonus code has been accepted": [
    null,
    "Se ha tenido en cuenta correctamente tu código bonus"
  ],
  "Your email address has not been verified. Please check your emails.": [
    null,
    "Todavía no has validado tu correo electrónico. Por favor, revisa tu bandeja de entrada."
  ],
  "Your grid has %1$s double": [
    "Your grid has %1$s doubles",
    "-",
    "-"
  ],
  "Your grid has been validated.": [
    null,
    "-"
  ],
  "Your grid will only be validated once it has been entirely financed.": [
    null,
    "-"
  ],
  "Your mission is simple:": [
    null,
    "Tu misión es simple:"
  ],
  "Your participation in the game has already been validated": [
    null,
    "Tu participación en el juego ya ha sido registrada"
  ],
  "Your turn to play!": [
    null,
    "¡Es tu turno!"
  ],
  "Your winning and ongoing bets already exceed the objective": [
    null,
    "Tus apuestas ganadas y en curso ya superan el objetivo"
  ],
  "Your winnings of %1$s will be credited to you as soon as all bets are settled.": [
    null,
    ""
  ],
  "abandoned": [
    null,
    "abandono"
  ],
  "already received": [
    null,
    "ya adquirido"
  ],
  "and %1$s triple": [
    "and %1$s triples",
    "-",
    "-"
  ],
  "break": [
    null,
    "descanso"
  ],
  "collected": [
    null,
    "recaudados"
  ],
  "delayed": [
    null,
    "aplazado"
  ],
  "events in progress": [
    null,
    "En directo"
  ],
  "extra innings": [
    null,
    "entrada adicional"
  ],
  "extra-time": [
    null,
    "prórroga"
  ],
  "extra-time - 1st half": [
    null,
    "prórroga - 1ª mitad"
  ],
  "extra-time - 2nd half": [
    null,
    "prórroga - 2ª mitad"
  ],
  "extra-time finished": [
    null,
    "final de la prórroga"
  ],
  "extra-time half-time": [
    null,
    "descanso de la prórroga"
  ],
  "extra-time will begin": [
    null,
    "va a comenzar la prórroga"
  ],
  "free": [
    null,
    "gratis"
  ],
  "gaming limits": [
    null,
    "en el siguiente enlace"
  ],
  "golden set": [
    null,
    "set de oro"
  ],
  "grid %1$s n°%2$s": [
    null,
    "- %1$s n°%2$s"
  ],
  "grids": [
    null,
    "-"
  ],
  "guaranteed": [
    null,
    "garantizado"
  ],
  "half-time": [
    null,
    "descanso"
  ],
  "handicap format": [
    null,
    "formato hándicap"
  ],
  "how it works": [
    null,
    "¿Cómo funciona?"
  ],
  "in progress": [
    null,
    "en curso"
  ],
  "including %1$s:": [
    null,
    "incluyendo %1$s:"
  ],
  "including rank 1 deferral:": [
    null,
    "incluyendo aplazamiento categoría 1:"
  ],
  "match abandoned": [
    null,
    "partido abandonado"
  ],
  "match delayed": [
    null,
    "partido aplazado"
  ],
  "match finished": [
    null,
    "partido terminado"
  ],
  "match in progress": [
    null,
    "partido en curso"
  ],
  "match interrupted": [
    null,
    "partido interrumpido"
  ],
  "match interuppted": [
    null,
    "partido interrumpido"
  ],
  "match postponed": [
    null,
    "partido aplazado"
  ],
  "match started": [
    null,
    "partido en curso"
  ],
  "missions:AlreadyOpted": [
    null,
    "Participación registrada"
  ],
  "missions:Log in": [
    null,
    "Conectarse"
  ],
  "missions:Opt in": [
    null,
    "Participo"
  ],
  "most popular": [
    null,
    "más apostados"
  ],
  "no events": [
    null,
    "Ningún evento"
  ],
  "n°": [
    null,
    "nº"
  ],
  "of the base": [
    "of %1$s bases",
    "del banker",
    "de %1$s bankers"
  ],
  "ok": [
    null,
    "Ok"
  ],
  "or": [
    null,
    "o"
  ],
  "overtime": [
    null,
    "prórroga"
  ],
  "overtime finished": [
    null,
    "prórroga finalizada"
  ],
  "overtime will begin": [
    null,
    "va a comenzar la prórroga"
  ],
  "own goal": [
    null,
    "gol en p.p."
  ],
  "pause": [
    null,
    "descanso"
  ],
  "penalty": [
    null,
    "penalti"
  ],
  "penalty shoot-out": [
    null,
    "tanda de penaltis"
  ],
  "retired": [
    null,
    "abandono"
  ],
  "selection": [
    "selections",
    "selección",
    "selecciones"
  ],
  "session break": [
    null,
    "tiempo muerto"
  ],
  "sudden death": [
    null,
    "muerte súbita"
  ],
  "text format": [
    null,
    "formato texto"
  ],
  "the 2nd quarter will begin": [
    null,
    "el 2º cuarto va a comenzar"
  ],
  "the 2nd set will begin": [
    null,
    "el 2º set va a comenzar"
  ],
  "the 3rd quarter will begin": [
    null,
    "el 3er periodo va a comenzar"
  ],
  "the 3rd set will begin": [
    null,
    "el 3er set va a comenzar"
  ],
  "the 4th quarter will begin": [
    null,
    "el 4º cuarto va a comenzar"
  ],
  "the 4th set will begin": [
    null,
    "el 4º set va a comenzar"
  ],
  "the 5th set will begin": [
    null,
    "el 5º set va a comenzar"
  ],
  "the Gift Race": [
    null,
    "Lluvia de regalos"
  ],
  "timer:d": [
    null,
    "d"
  ],
  "timer:finished": [
    null,
    "Terminado"
  ],
  "timer:h": [
    null,
    "h"
  ],
  "timer:min": [
    null,
    "min"
  ],
  "up to": [
    null,
    "hasta"
  ],
  "walkover": [
    null,
    "walkover"
  ],
  "with your next deposit": [
    null,
    "con tu próximo depósito"
  ]
}
  }
}
